import type { KonvaEventObject } from 'konva/lib/Node';
import type { DrawMode } from './slice';

/**
 * Lucide "pipette" path with a white halo so the cursor stays legible on both
 * dark and light pixels. Hotspot anchored at the dropper tip (bottom-left).
 */
const EYEDROPPER_PATHS = [
  'm2 22 1-1h3l9-9',
  'M3 21v-3l9-9',
  'm15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z',
];
const EYEDROPPER_SVG =
  `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">` +
  `<g fill="none" stroke-linecap="round" stroke-linejoin="round">` +
  `<g stroke="white" stroke-width="3.5">${EYEDROPPER_PATHS.map((d) => `<path d="${d}"/>`).join('')}</g>` +
  `<g stroke="black" stroke-width="1.6">${EYEDROPPER_PATHS.map((d) => `<path d="${d}"/>`).join('')}</g>` +
  `</g></svg>`;

const EYEDROPPER_CURSOR = `url("data:image/svg+xml;utf8,${encodeURIComponent(EYEDROPPER_SVG)}") 2 22, copy`;

/** Cursor for the stage container while a draw mode is active. Per-node hover
 *  handlers set their own cursor on top of this when drawMode === 'none'. */
export const STAGE_CURSORS: Record<DrawMode, string> = {
  none: 'default',
  crop: 'crosshair',
  watermark: 'crosshair',
  pickBg: EYEDROPPER_CURSOR,
  keyRegion: 'crosshair',
  erase: 'none',
  pan: 'grab',
  selectRegion: 'crosshair',
};

/** Set the stage container's CSS cursor from a Konva event. Pass an empty
 *  string to clear and let the container's own CSS take over. */
export function setStageCursor(e: KonvaEventObject<Event>, cursor: string): void {
  const stage = e.target.getStage();
  if (stage) stage.container().style.cursor = cursor;
}
